module.exports = __webpack_public_path__ + "img/mail.5fbb3d5.svg";